import { css } from '@emotion/css';

export const tagCss = css`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #525759;
  border-radius: 8px;
  padding: 6px 8px;
`;

export const unsupportedTagCss = css`
  opacity: 0.5;
`;
